export class SupplierClassification {
  id?: number;
  name?: string;
  nameEnglish?: string;
}
